import { EntidadeBase } from 'hay-core-react';
class ContratoUtilizacaoModel extends EntidadeBase {
    constructor() { super('contratoutilizacao'); }
}

const instance = new ContratoUtilizacaoModel();
export default instance;
